<template>
  <div>
    <Loading v-if="isLoading" />
    <div class="category-container" v-if="isCategory">
      <v-radio-group v-model="select">
        <v-radio
          v-for="(i, idx) in $utils.catgeories()"
          :key="idx"
          :label="`${i.name}`"
          :value="i.value"
          @click="() => (select = i.value)"
        ></v-radio>
      </v-radio-group>
      <div class="mt-5">
        <Button
          name="TERAPKAN"
          width="100%"
          height="40px"
          @click="onFilterClass"
        />
      </div>
    </div>

    <div class="container-body-mobile pb-10">
      <div v-for="item in schedules" :key="item.class_id">
        <CardClass :data="item" />
      </div>
      <div class="button-filter" v-if="!isCategory">
        <Button
          name="KATEGORI"
          height="40px"
          width="80%"
          @click="() => (isCategory = true)"
          ><Grow
        /></Button>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "../../others/Button.vue";
import Grow from "@/assets/icons/Grow.vue";
import Loading from "../../others/Loading.vue";
import CardClass from "../../others/CardClass.vue";

export default {
  data() {
    return {
      schedules_list: [],
      schedules: [],
      select: 0,
      isTester: this.$decode_token["email"].search("tester") < 0 ? false : true,
      isCategory: false,
      limitText: 240,
      isLoading: false,
    };
  },
  components: {
    CardClass,
    Button,
    Loading,
    Grow,
  },
  methods: {
    onFilterClass() {
      if (!this.select) this.schedules = this.schedules_list;
      else
        this.schedules = this.schedules_list.filter(
          (item) => item.category === this.select
        );
      this.isCategory = false;
    },
    async getClass() {
      this.isLoading = true;
      this.schedules = [];
      this.schedules_list = [];
      await this.$http
        .get(
          "/v1/user-schedule?user_id=" +
            this.$decode_token["id"] +
            "&status=true"
        )
        .then(async (response) => {
          for (let i = 0; i < response.data.data.schedules.length; i++) {
            const item = response.data.data.schedules[i];
            this.schedules.push(item);
            this.schedules_list.push(item);
          }
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
  mounted() {
    this.getClass();
  },
};
</script>

<style scoped>
.title {
  font-weight: bold;
  font-size: 15px !important;
  line-height: 19px !important;
  color: #36373f;
  margin-top: 15px;
}
.img-class {
  height: 80px;
  width: 80px;
  border-radius: 16px;
}

.name-circle {
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: linear-gradient(111.75deg, #179eff -0.58%, #162ca2 100.82%);
}
.container-chat {
  margin-top: 10px;
  padding: 5px 19px;
  border-radius: 18px;
  position: relative;
  z-index: 10px;
  border: 1px solid #d3d6e1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.container-chat .content {
  display: flex;
  gap: 8px;
  align-items: center !important;
}
</style>
